import { createContext, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FormattedMessage, IntlProvider } from "react-intl";
import { Flex, IconBtn, LogoutIcon, Text } from "@paguelofacil/pf-components";

import useStore from "../../services/store/useStore";
import { useWidthSize } from "../../hooks/useWidthSize";
import { useGetSessionCryptofacil } from "../../hooks/useGetSessionCryptofacil";
import { ManageService } from "../../services/Services";
import { language, languageDefault } from "../../services/utils/Language";
import LogoCryptoFacil from "../../assets/images/logo-cryptofacil.png";
import LogoCryptoFacilIcon from "../../assets/images/icon-cfacil.png";
import { clearAllStorage } from "../../services/utils/StorageUtils";

import { SelectorLenguages } from "../../components/SelectorLanguage";
import { AvatarDefault } from "../../components/Avatar";
import Version from "./Version";

import "../../assets/scss/layout.scss";

export const LangContext = createContext(null);

const Layout = () => {
    useGetSessionCryptofacil();
    const navigate = useNavigate();
    const location = useLocation();
    const { widthSize } = useWidthSize();
    const userData = useStore(state => state.user);
    const setUserData = useStore(state => state.setUserData);

    let navigatorLang = window.navigator.language || navigator.browserLanguage;

    const lang = useStore(state => state.lang);
    const setLang = useStore(state => state.setLang);

    const catalogLang = useStore(state => state.catalogLang);
    const setCatalogLang = useStore(state => state.setCatalogLang);

    const getLang = () =>
        ManageService.getLanguage(lang).then(response => {
            setCatalogLang(response);
        });

    const onLogout = () => {
        clearAllStorage();
        setUserData(null);
        navigate("/");
    };

    /** Start in Language */
    useEffect(() => {
        if (lang) {
            getLang(lang);
        } else {
            if (navigatorLang) {
                if (navigatorLang.toUpperCase().includes("ES")) setLang("ES");
                else setLang("EN");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang]);

    return (
        <LangContext.Provider value={lang}>
            <IntlProvider defaultLocale="ES" locale={lang} messages={catalogLang}>
                <Flex
                    className={`layout-main ${
                        location.pathname === "/" || location.pathname === "/cryptofacil/home" ? "home" : "no-home"
                    }`}
                    bg={location.pathname === "/" || location.pathname === "/cryptofacil/home" ? "" : "#F2F3F5"}
                    direction={location.pathname === "/cryptofacil" ? "" : "column"}
                    align="flex-start"
                    height="auto"
                    minH="100vh"
                    gap="0"
                >
                    <Flex
                        wrap="nowrap"
                        className="header-main"
                        height="2rem"
                        justify="space-between"
                        gap={widthSize <= 480 ? "0.5rem" : "1rem"}
                    >
                        <img
                            src={widthSize <= 850 ? LogoCryptoFacilIcon : LogoCryptoFacil}
                            alt="Logo cryptofacil"
                            className={widthSize <= 850 ? "img-logo-cryptofacil-mobile" : "img-logo-cryptofacil"}
                        />
                        <Flex
                            direction="row"
                            wrap="no-wrap"
                            align="center"
                            width="auto"
                            minW="auto"
                            gap={widthSize <= 480 ? "0.5rem" : "1.5rem"}
                        >
                            {userData ? (
                                <Flex
                                    direction="row"
                                    wrap="no-wrap"
                                    align="center"
                                    width="auto"
                                    minW="auto"
                                    gap="0.5rem"
                                >
                                    <Text variant={widthSize <= 480 ? "caption" : "body6"}>
                                        <FormattedMessage id={language.hello} defaultMessage={languageDefault.hello} />
                                        &nbsp;
                                        {`${userData?.name} ${userData?.lastname}`}
                                    </Text>
                                    <AvatarDefault
                                        name={`${userData?.name} ${userData?.lastname}`}
                                        padding={widthSize <= 480 ? "4px" : "5px"}
                                        fontSize={widthSize <= 480 ? "0.7rem" : "0.75rem"}
                                    />
                                    <IconBtn
                                        handleClick={onLogout}
                                        variant="transparent"
                                        className="button-link-header"
                                    >
                                        <LogoutIcon size="24" color="#378fa2" />
                                    </IconBtn>
                                </Flex>
                            ) : (
                                <></>
                            )}
                            <SelectorLenguages setLang={setLang} />
                        </Flex>
                    </Flex>
                    <Outlet />
                    <Version />
                </Flex>
            </IntlProvider>
        </LangContext.Provider>
    );
};

export default Layout;
